import React from 'react';
import styled, { css } from 'styled-components';
import { Spotlight } from 'api/spotlight/types';
import { Avatar } from 'components/atoms/avatar';
import { CpBody0aPrimary } from 'components/atoms/customer-portal/typography';
import { SpotlightMessageInverse20 } from 'components/atoms/icons/spotlight-message-inverse';
import { SingleLineEllipsis } from 'components/styles';
import { useGetUserByUserId } from 'hooks/use-idb';
import { fullName } from 'utils/full-name';
import {
  SpotlightAsMessage,
  SpotlightMessageListPopover,
} from './spotlight-in-tag';

interface Props {
  spotlight: Spotlight;
  isMessageSpotlight?: boolean;
  className?: string;
}

const Icon = styled(SpotlightMessageInverse20)``;

const Wrapper = styled.div<{ isMessageSpotlight: boolean }>`
  width: fit-content;
  max-width: 100%;
  padding: var(--cp-spacing-02) var(--cp-spacing-05);
  background: #f7ae58;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: start;
  position: relative;
  height: 32px;
  ${Icon} {
    flex-shrink: 0;
  }
  gap: var(--spacing-03);
  &:before {
    ${({ isMessageSpotlight }) =>
      isMessageSpotlight
        ? css`
            content: '';
          `
        : ''};
    width: 12px;
    height: 12px;
    display: block;
    border: 8px solid;
    position: absolute;
    left: 2px;
    bottom: 8px;
    z-index: 1;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: #f7ae58;
    border-bottom-width: 12px;
    transform: rotateZ(215deg);
    transform-origin: bottom;
  }
`;

const Content = styled(CpBody0aPrimary)`
  width: calc(100% - 20px);
  display: flex;
  align-items: center;
  justify-content: start;
  gap: var(--cp-spacing-03);
`;
const Text = styled(CpBody0aPrimary)`
  ${SingleLineEllipsis};
`;

const SpotlightUI: React.FC<Props> = ({
  spotlight,
  className,
  isMessageSpotlight = false,
}) => {
  const user = useGetUserByUserId(spotlight?.createdBy);

  return (
    <SpotlightMessageListPopover
      getPopupContainer={() =>
        document.querySelector('.rl-cp-page') || document.body
      }
      placement="bottomLeft"
      overlayInnerStyle={{ borderRadius: 'var(--border-radius-small)' }}
      // destroyTooltipOnHide
      content={
        <SpotlightAsMessage
          onSpotlightClick={() => {}}
          key={spotlight?.customerResourcePinnedMappingId}
          spotlight={spotlight}
        />
      }
    >
      <Wrapper className={className} isMessageSpotlight={isMessageSpotlight}>
        <Icon />
        <Content>
          {user ? (
            <Avatar size="small" src={user?.photoUrl} name={fullName(user)} />
          ) : (
            <></>
          )}
          <Text>{spotlight.caption}</Text>
        </Content>
      </Wrapper>
    </SpotlightMessageListPopover>
  );
};

export const SpotlightForTasklist = styled(SpotlightUI)``;
